import React from "react";
// javascipt plugin for creating charts
import { Chart, registerables } from "chart.js";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
// @material-ui/icons components

// core components
import { chartExample7 } from "variables/charts.js";

import boxShadows from "assets/theme/box-shadow.js";

Chart.register(...registerables);

function CardSalesValueAlternative() {
  const theme = useTheme();
  return (
    <>
      <Card
        sx={{
          boxShadow: boxShadows.boxShadow + "!important",
          border: "0!important",
        }}
      >
        <CardHeader
          title={
            <Box component="span" sx={{ color: theme.palette.gray[600] }}>
              Overview
            </Box>
          }
          subheader="Sales value"
          sx={{ backgroundColor: "initial!important" }}
          titleTypographyProps={{
            component: Box,
            variant: "h6",
            sx: {
              letterSpacing: "2px",
              marginBottom: "0!important",
              textTransform: "uppercase",
            },
          }}
          subheaderTypographyProps={{
            component: Box,
            variant: "h3",
            sx: { marginBottom: "0!important", color: theme.palette.dark.main },
          }}
        ></CardHeader>
        <CardContent>
          <Box sx={{ position: "relative", height: "420px" }}>
            <Line
              data={chartExample7.data}
              options={chartExample7.options}
              getDatasetAtEvent={(e) => console.log(e)}
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
}

export default CardSalesValueAlternative;
